import * as msal from "@azure/msal-browser";

let msalApp;

export default {
  async configure(clientId) {
    if (msalApp) {
      return;
    }

    const config = {
      auth: {
        clientId: clientId,
        redirectUri: window.location.origin,
        authority: "https://login.microsoftonline.com/common",
      },
      cache: {
        cacheLocation: "localStorage",
      },
      // Only uncomment when you *really* need to debug what is going on in MSAL
      /* system: {
        logger: new msal.Logger(
          (logLevel, msg) => { console.log(msg) },
          {
            level: msal.LogLevel.Verbose
          }
        )
      } */
    };

    msalApp = new msal.PublicClientApplication(config);
  },

  clientId() {
    if (!msalApp) {
      return null;
    }
    return msalApp.config.auth.clientId;
  },

  // login
  async login(scopes = ["user.read", "openid", "profile", "email"]) {
    if (!msalApp) {
      return;
    }

    //const LOGIN_SCOPES = ['user.read', 'openid', 'profile', 'email']
    await msalApp.loginPopup({
      scopes,
      prompt: "select_account",
    });
  },

  // logout
  logout() {
    if (!msalApp) {
      return;
    }

    msalApp.logoutPopup();
  },

  // get user
  user() {
    if (!msalApp) {
      return null;
    }

    const currentAccounts = msalApp.getAllAccounts();
    if (!currentAccounts || currentAccounts.length === 0) {
      // No user signed in
      return null;
    } else if (currentAccounts.length > 1) {
      return currentAccounts[0];
    } else {
      return currentAccounts[0];
    }
  },

  // acquireTokenSilent // acquireTokenPopup
  async acquireToken(scopes = ["user.read"]) {
    if (!msalApp) {
      return null;
    }

    // Set scopes for token request
    const accessTokenRequest = {
      scopes,
      account: this.user(),
    };

    let tokenResp;
    try {
      // 1. Try to acquire token silently
      tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest);
      console.log("### MSAL acquireTokenSilent was successful");
    } catch (err) {
      // 2. Silent process might have failed so try via popup
      tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest);
      console.log("### MSAL acquireTokenPopup was successful");
    }

    // Just in case check, probably never triggers
    if (!tokenResp.accessToken) {
      throw new Error("### accessToken not found in response, that's bad");
    }

    return tokenResp.accessToken;
  },

  // clear local user
  clearLocal() {
    if (msalApp) {
      for (let entry of Object.entries(localStorage)) {
        let key = entry[0];
        if (key.includes("login.windows")) {
          localStorage.removeItem(key);
        }
      }
    }
  },

  // check if configurerd
  isConfigured() {
    return msalApp != null;
  },
};
